import { z } from 'zod';
import * as m from '@paraglide/messages';

const serviceNames = ['app', 'db', 'marketplace', 'llm'] as const;

interface IServiceSelect {
  name: (typeof serviceNames)[number];
  label: string;
}

const serviceSchema = z.object({
  serviceType: z.enum(serviceNames),
  projectType: z.string().min(1, 'Project type is required'),
});

type ServiceFormValues = z.infer<typeof serviceSchema>;

const tariffSchema = z.object({
  name: z.string().min(1, m.required_field()),
  tariffId: z.coerce.number(),
  resourcesQuota: z
    .object({
      VOLUME: z.object({
        tariffId: z.coerce.number(),
        resourceType: z.string().optional(),
        resourceClass: z.string().optional(),
        quota: z.number().optional(),
      }),
    })
    .optional(),
});

type TariffFormValues = z.infer<typeof tariffSchema>;

const quotaSchema = z.object({
  tariffId: z.coerce.number(),
  resourceType: z.string(),
  resourceClass: z.string(),
  quota: z.number(),
});

type QuotaFormValues = z.infer<typeof quotaSchema>;

export { serviceSchema, tariffSchema };
export type {
  IServiceSelect,
  QuotaFormValues,
  ServiceFormValues,
  TariffFormValues,
};
